import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

// import icons
import IconTick from 'js/components/icon/Icon.tick';

export default function ButtonTickState({ action = () => {}, selected = false, iconColor = '#fff', style = {} }) {
  return (
    <button
      onClick={action}
      className={`button__tick-state ${selected ? 'button__tick-state--added' : 'button__tick-state--not-added'}`}
      style={style}
    >
      <AnimatePresence>
        {selected && (
          <motion.div
            key="button-tick-icon"
            initial={{ scale: selected ? 1 : 0 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0 }}
            transition={{
              duration: 0.75,
              type: 'spring',
              bounce: 0.4,
            }}
          >
            <IconTick color={iconColor} />
          </motion.div>
        )}
      </AnimatePresence>
    </button>
  );
}
